import { useEffect, useState } from "react";
import { productPanelStyle, red } from "./MerchStyles";

const designDisplay = {
  "identity-tee": "VEHICLE IDENTITY",
  "archive-tee": "BUILD ARCHIVE",
  "scan-my-build-tee": "SCAN MY BUILD"
};

const colorTones = {
  "Faded Black": { shirt: "#171717", ink: "#f0f0f0" },
  "Faded Bone": { shirt: "#d8d0c2", ink: "#171717" },
  "Faded Coal": { shirt: "#3b3b3b", ink: "#f0f0f0" }
};

function MerchProductVisual({ product, color = "Faded Black", view = "back", imageSrc = null, compact = false, className = "" }) {
  const [imageFailed, setImageFailed] = useState(false);
  const tone = colorTones[color] || colorTones["Faded Black"];
  const isBack = view === "back";
  const isScanBack = product.id === "scan-my-build-tee" && isBack;
  const usableImage = imageSrc && !imageFailed;

  useEffect(() => {
    setImageFailed(false);
  }, [imageSrc]);

  const handleImageError = () => {
    console.warn(`[Merch Engine] Could not load ${product.id} ${color} ${view} image; using temporary preview.`);
    setImageFailed(true);
  };

  const containerStyle = {
    ...productPanelStyle,
    aspectRatio: "4 / 5",
    minHeight: compact ? productPanelStyle.minHeight : "620px"
  };

  if (usableImage) {
    return (
      <div className={`${compact ? "merch-visual-compact " : "merch-visual-large "}${className}`.trim()} style={containerStyle}>
        <img
          src={imageSrc}
          alt={`${product.name} in ${color}, ${view} view`}
          onError={handleImageError}
          style={{ display: "block", width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }}
        />
      </div>
    );
  }

  return (
    <div
      className={`${compact ? "merch-visual-compact " : "merch-visual-large "}${className}`.trim()}
      style={containerStyle}
      role="img"
      aria-label={`${product.name} ${view} temporary preview in ${color}`}
    >
      <span aria-hidden="true" style={{ position: "absolute", inset: "9% 10% auto auto", fontSize: compact ? "86px" : "clamp(90px, 15vw, 180px)", fontWeight: 900, color: "rgba(255,255,255,.025)", letterSpacing: "-.08em" }}>MBID</span>
      <div aria-hidden="true" className="merch-garment-silhouette" style={{ position: "absolute", width: "68%", height: "74%", background: tone.shirt, clipPath: "polygon(25% 0,39% 8%,61% 8%,75% 0,100% 18%,85% 37%,76% 30%,79% 100%,21% 100%,24% 30%,15% 37%,0 18%)", filter: "drop-shadow(0 20px 22px rgba(0,0,0,.48))", transition: "background-color 200ms ease" }} />
      <div style={{ position: "relative", zIndex: 1, width: "48%", color: tone.ink, textAlign: "center" }}>
        <span style={{ display: "block", width: "30px", height: "3px", margin: "0 auto 12px", background: red }} />
        <strong style={{ display: "block", fontSize: compact ? "15px" : "clamp(15px, 2vw, 22px)", lineHeight: 1.05, letterSpacing: "1px", textTransform: "uppercase" }}>
          {isBack ? designDisplay[product.id] || product.name : "Official MyBuildID logo placement"}
        </strong>
        {isScanBack && <QrPlacement tone={tone} />}
      </div>
      <div className="merch-preview-label" style={{ position: "absolute", left: "22px", right: "22px", bottom: "18px", display: "flex", justifyContent: "space-between", gap: "12px", color: "#888", fontSize: "9px", fontWeight: 800, letterSpacing: "1.2px", textTransform: "uppercase" }}>
        <span>{product.name}</span>
        <span>Temporary {view} preview</span>
      </div>
    </div>
  );
}

function QrPlacement({ tone }) {
  return (
    <>
      <span aria-hidden="true" className="merch-qr-placeholder" style={{ display: "block", width: "58px", height: "58px", margin: "14px auto 8px", border: `1px solid ${tone.ink}`, outline: `1px solid ${tone.ink}`, outlineOffset: "5px", opacity: .65 }} />
      <span style={{ display: "block", fontSize: "8px", letterSpacing: ".8px", textTransform: "uppercase" }}>QR placement preview</span>
    </>
  );
}

export default MerchProductVisual;
